module.exports = __webpack_public_path__ + "img/loader.bb398c2e.svg";